import { inject, Injectable } from "@angular/core";
import { Led } from "@nettask/hxa-capacitor-led-plugin";
import { environment } from "src/environments/environment";
import { VariantService } from "../variant-service/variant.service";

@Injectable({
	providedIn: "root",
})
export class LedControllerService {
	FlashinRedLedInterval: any;
	private ledReady: Promise<void> = Promise.resolve();
	private led: null | typeof import("@nettask/hxa-capacitor-led-plugin").Led = null;

	private variantService = inject(VariantService);

	constructor() {
		if (this.variantService.isHxaDevices) {
			this.ledReady = import("@nettask/hxa-capacitor-led-plugin").then((module) => {
				this.led = module.Led;
			});
		}
	}

	public async applyRedBlinkingEffect() {
		if (this.variantService.isHxaDevices) {
			await this.ledReady;
			this.led.setLedRed();
			let isOn = true;
			if (this.FlashinRedLedInterval == null) {
				this.FlashinRedLedInterval = setInterval(() => {
					if (isOn) {
						this.led.setLedBlack();
					} else {
						this.led.setLedRed();
					}
					isOn = !isOn;
				}, 750);
			}
		}
	}
	public setLedWhite() {
		if (this.variantService.isHxaDevices) {
			if (this.FlashinRedLedInterval != null) {
				clearInterval(this.FlashinRedLedInterval);
				this.FlashinRedLedInterval = null;
			}
			setTimeout(async () => {
				await this.ledReady;
				this.led.setLedWhite();
			}, 759);
		}
	}
	public async setLedGreen() {
		if (this.variantService.isHxaDevices) {
			await this.ledReady;
			this.led.setLedGreen();
		}
	}
}
